export const ANSWERS_DATA = {
  keyword: [
    {
      st1: {
        answerData: "st1",
        DateVal: "infoData1",
        titImgclassName: "messageTit01",
      },
      bjh32: {
        answerData: "q1",
        DateVal: "quiz01",
        titImgclassName: "messageTit01",
      },
      isy29: {
        answerData: "q2",
        DateVal: "quiz02",
        titImgclassName: "messageTit01",
      },
      cms27: {
        answerData: "q3",
        DateVal: "quiz03",
        titImgclassName: "messageTit01",
      },
      khl31: {
        answerData: "q4",
        DateVal: "quiz04",
        titImgclassName: "messageTit01",
      },
      jws38: {
        answerData: "q5",
        DateVal: "quiz05",
        titImgclassName: "messageTit01",
      },
      map12: {
        answerData: "q6",
        DateVal: "quiz06",
        titImgclassName: "messageTit01",
      },
      nta24: {
        answerData: "q7",
        DateVal: "quiz07",
        titImgclassName: "messageTit01",
      },
      sdw25: {
        answerData: "q8",
        DateVal: "quiz08",
        titImgclassName: "messageTit01",
      },
      mpt23: {
        answerData: "q9",
        DateVal: "quiz09",
        titImgclassName: "messageTit01",
      },
      kpw26: {
        answerData: "q10",
        DateVal: "quiz10",
        titImgclassName: "messageTit01",
      },
      bdy20: {
        answerData: "q11",
        DateVal: "quiz11",
        titImgclassName: "messageTit01",
      },
      mog29: {
        answerData: "q12",
        DateVal: "quiz12",
        titImgclassName: "messageTit01",
      },
      cle01: {
        answerData: "q13",
        DateVal: "quiz13",
        titImgclassName: "messageTit01",
      },
      gar02: {
        answerData: "q14",
        DateVal: "quiz14",
        titImgclassName: "messageTit01",
      },
      del03: {
        answerData: "q15",
        DateVal: "quiz15",
        titImgclassName: "messageTit01",
      },
      sto04: {
        answerData: "q16",
        DateVal: "quiz16",
        titImgclassName: "messageTit01",
      },
      hrd05: {
        answerData: "q17",
        DateVal: "quiz17",
        titImgclassName: "messageTit01",
      },
      loc06: {
        answerData: "q18",
        DateVal: "quiz18_q",
        titImgclassName: "messageTit01",
      },
      smk01: {
        answerData: "q19",
        DateVal: "quiz19",
        titImgclassName: "messageTit01",
      },
      sr02: {
        answerData: "q20",
        DateVal: "quiz20",
        titImgclassName: "messageTit01",
      },
      fc03: {
        answerData: "q21",
        DateVal: "quiz21",
        titImgclassName: "messageTit01",
      },
      sta04: {
        answerData: "q22",
        DateVal: "quiz22",
        titImgclassName: "messageTit01",
      },
      dra05: {
        answerData: "q23",
        DateVal: "quiz23",
        titImgclassName: "messageTit01",
      },
      caf06: {
        answerData: "q24",
        DateVal: "quiz24",
        titImgclassName: "messageTit01",
      },
      sbt07: {
        answerData: "q25",
        DateVal: "quiz25_q",
        titImgclassName: "messageTit01",
      },
      pho01: {
        answerData: "q26",
        DateVal: "quiz26",
        titImgclassName: "messageTit01",
      },
      evi02: {
        answerData: "q27",
        DateVal: "quiz27",
        titImgclassName: "messageTit01",
      },
      wit03: {
        answerData: "q28",
        DateVal: "quiz28",
        titImgclassName: "messageTit01",
      },
      fin04: {
        answerData: "q29",
        DateVal: "quiz29",
        titImgclassName: "messageTit01",
      },
      lck05: {
        answerData: "q30",
        DateVal: "quiz30_q",
        titImgclassName: "messageTit01",
      },
      clu06: {
        answerData: "q31",
        DateVal: "quiz31_q",
        titImgclassName: "messageTit01",
      },
      khr07: {
        answerData: "q32",
        DateVal: "quiz32",
        titImgclassName: "messageTit01",
      },
      jws08: {
        answerData: "q33",
        DateVal: "quiz33",
        titImgclassName: "messageTit01",
      },
      end11: {
        answerData: "end_q1",
        DateVal: "end_q1",
        titImgclassName: "finalQuizTit",
      },
      ih01: {
        type: "place",
        keyword: "ih01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ih01.png",
          },
        ],
      },
      ih02: {
        type: "place",
        keyword: "ih02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ih02.png",
          },
        ],
      },
      ih03: {
        type: "place",
        keyword: "ih03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ih03.png",
          },
        ],
      },
      ih04: {
        type: "place",
        keyword: "ih04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ih04.png",
          },
        ],
      },
      ih05: {
        type: "place",
        keyword: "ih05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ih05.png",
          },
        ],
      },
      sv01: {
        type: "place",
        keyword: "sv01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_sv01.png",
          },
        ],
      },
      sv02: {
        type: "place",
        keyword: "sv02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_sv02.png",
          },
        ],
      },
      sv03: {
        type: "place",
        keyword: "sv03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_sv03.png",
          },
        ],
      },
      sv04: {
        type: "place",
        keyword: "sv04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_sv04.png",
          },
        ],
      },
      sv05: {
        type: "place",
        keyword: "sv05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_sv05.png",
          },
        ],
      },
      lo01: {
        type: "place",
        keyword: "lo01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_lo01.png",
          },
        ],
      },
      lo02: {
        type: "place",
        keyword: "lo02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_lo02.png",
          },
        ],
      },
      lo03: {
        type: "place",
        keyword: "lo03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_lo03.png",
          },
        ],
      },
      lo04: {
        type: "place",
        keyword: "lo04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_lo04.png",
          },
        ],
      },
      lo05: {
        type: "place",
        keyword: "lo05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_lo05.png",
          },
        ],
      },
      ga01: {
        type: "place",
        keyword: "ga01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ga01.png",
          },
        ],
      },
      ga02: {
        type: "place",
        keyword: "ga02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ga02.png",
          },
        ],
      },
      ga03: {
        type: "place",
        keyword: "ga03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ga03.png",
          },
        ],
      },
      ga04: {
        type: "place",
        keyword: "ga04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ga04.png",
          },
        ],
      },
      ga05: {
        type: "place",
        keyword: "ga05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ga05.png",
          },
        ],
      },
      gr01: {
        type: "place",
        keyword: "gr01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_gr01.png",
          },
        ],
      },
      gr02: {
        type: "place",
        keyword: "gr02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_gr02.png",
          },
        ],
      },
      gr03: {
        type: "place",
        keyword: "gr03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_gr03.png",
          },
        ],
      },
      gr04: {
        type: "place",
        keyword: "gr04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_gr04.png",
          },
        ],
      },
      gr05: {
        type: "place",
        keyword: "gr05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_gr05.png",
          },
        ],
      },
      le01: {
        type: "place",
        keyword: "le01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_le01.png",
          },
        ],
      },
      le02: {
        type: "place",
        keyword: "le02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_le02.png",
          },
        ],
      },
      le03: {
        type: "place",
        keyword: "le03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_le03.png",
          },
        ],
      },
      le04: {
        type: "place",
        keyword: "le04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_le04.png",
          },
        ],
      },
      le05: {
        type: "place",
        keyword: "le05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_le05.png",
          },
        ],
      },
      op01: {
        type: "place",
        keyword: "op01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_op01.png",
          },
        ],
      },
      op02: {
        type: "place",
        keyword: "op02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_op02.png",
          },
        ],
      },
      op03: {
        type: "place",
        keyword: "op03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_op03.png",
          },
        ],
      },
      op04: {
        type: "place",
        keyword: "op04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_op04.png",
          },
        ],
      },
      op05: {
        type: "place",
        keyword: "op05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_op05.png",
          },
        ],
      },
      wi01: {
        type: "place",
        keyword: "wi01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_wi01.png",
          },
        ],
      },
      wi02: {
        type: "place",
        keyword: "wi02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_wi02.png",
          },
        ],
      },
      wi03: {
        type: "place",
        keyword: "wi03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_wi03.png",
          },
        ],
      },
      wi04: {
        type: "place",
        keyword: "wi04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_wi04.png",
          },
        ],
      },
      wi05: {
        type: "place",
        keyword: "wi05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_wi05.png",
          },
        ],
      },
      ha01: {
        type: "place",
        keyword: "ha01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ha01.png",
          },
        ],
      },
      ha02: {
        type: "place",
        keyword: "ha02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ha02.png",
          },
        ],
      },
      ha03: {
        type: "place",
        keyword: "ha03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ha03.png",
          },
        ],
      },
      ha04: {
        type: "place",
        keyword: "ha04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ha04.png",
          },
        ],
      },
      ha05: {
        type: "place",
        keyword: "ha05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_ha05.png",
          },
        ],
      },
      el01: {
        type: "place",
        keyword: "el01",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_el01.png",
          },
        ],
      },
      el02: {
        type: "place",
        keyword: "el02",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_el02.png",
          },
        ],
      },
      el03: {
        type: "place",
        keyword: "el03",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_el03.png",
          },
        ],
      },
      el04: {
        type: "place",
        keyword: "el04",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_el04.png",
          },
        ],
      },
      el05: {
        type: "place",
        keyword: "el05",
        titClass: "placeTit",
        content: [
          {
            type: "chatInfo_Talk1",
            marType: "mb20",
            text: `
            장소로 이동해 <br/> 아래 사진 힌트를 보고 코드를 찾으세요.
          `,
          },
          {
            type: "ImgOnly",
            marType: "",
            className: "chatFullImg",
            src: "/img/place/img_location_el05.png",
          },
        ],
      },
    },
  ],
};
